/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useCallback } from 'react';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLModalService } from 'ml-portals-services-react';
import { MLDisclosureUtil, MLEndorsementFlowUtil } from 'ml-portals-util-js';
import { MLDisclosureComponent, MLScriptComponent } from 'ml-components-common-react';
import { MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import { MLPortalStorageService, MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLTagManagerService } from 'ml-portals-services-react';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import '@xengage/gw-platform-translations';
import _ from 'lodash';

import { platformMessages } from 'ml-components-platform-react';
import messages from './DisclosurePagePolChange.messages';
import paMetadata from './PADisclosurePagePolChange.metadata.json5';
import pupMetadata from './PUPDisclosurePagePolChange.metadata.json5';

const mvrExecutedStates = ['endorsementPaDisclosures', 'endorsementPupDisclosures'];
const PA_LIC_SUSP_LICENSE_SUSPENDED_TYPE = 'license_is_suspended_revoked';
const PA_LIC_SUSP_LICENSE_SUSPENDED_CODE = '12011';
const PA_LIC_SUSP_INCIDENT_THRESHOLD_IN_YEARS = 3;
const PA_LIC_SUSP_DRIVERS_AGE_THRESHOLD = 24;
const currentYear = new Date().getFullYear();
// Block id for the "premium may have changed" warning so it can only ever be shown once,
// regardless of which code path (MVR dedup or premium-changed-by-MVR) triggers it.
const PREMIUM_CHANGED_ALERT_BLOCK = 'adjustedPremiumMessageContainer';

// ML: MLDisclosureCtrl.js, agent/MLDisclosureCtrl.js, ml-pa-disclosure.html, ml-pup-disclosure.html

function DisclosurePagePolChange(props) {
    const translator = useTranslator();

    const { authHeader } = useAuthentication();
    const {
        wizardData, goNext, currentStep, steps, jumpTo, updateWizardData, changeNextSteps
    } = props;
    const { submissionVM: endorsementVM } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');

    const {
        ML_STORAGE_KEY_PREVIOUS_PREMIUM,
        MLUWIssuesBlockingPoints
    } = appConfig;

    const {
        showProgressDialog
    } = MLModalService();

    const {
        checkHiDrivers,
        checkPendingMvrOrderStatus,
    } = MLDriverVehicleUtil();


    const {
        clearBlockAlerts,
        addWarningAlert,
        addErrorAlert
    } = MLNotificationBlockUtil();


    const isAgent = appConfig.portalCode === 'GPA';
    const { isComponentValid } = useValidation(currentStep.id);
    const quoteID = _.get(endorsementVM, 'jobID.value')

    // init
    const [premiumChangedByMVRFlag, updatePremiumChangedByMVRFlag] = useState(undefined);

    const isPersonalAuto = endorsementVM.value.isPersonalAuto();
    const isPersonalUmbrella = endorsementVM.value.isPersonalUmbrella();

    const lobModel = isPersonalAuto ? _.get(endorsementVM, 'lobData.personalAuto.coverables') : _.get(endorsementVM, 'lobData.personalUmbrella.coverables');    
    const mvrExecuted = mvrExecutedStates.indexOf(currentStep.mlStepName) >= 0;
    const userHasEditDisclosuresPermission = !mvrExecuted;
    const [paSuspensionMessagedDisplayed, updatePaSuspensionMessagedDisplayed] = useState(false);
    const discloseExcludedDriver = _.get(endorsementVM, 'baseData.canDiscloseExcludedDrivers_ML.value') || false;
    const policyHolder = _.get(endorsementVM, 'baseData.policyContact_ML.displayName.value');

    const [accidents, setAccidents] = useState([]);
    const [claims, setClaims] = useState([]);
    const [violations, setViolations] = useState([]);
    const [losses, setLosses] = useState([]);
    const [uwIssues, setUwIssues] = useState([]);
    const [showDisclosuresPagePolChange, setShowDisclosuresPagePolChange] = useState(!mvrExecuted);

    const setPremiumChangedByMVRFlag = () => {
        const getSelectedQuote = () => {
            if (endorsementVM.bindData && endorsementVM.bindData.chosenQuote
                && endorsementVM.quoteData && endorsementVM.quoteData.offeredQuotes) {
                const selectedQuoteId = endorsementVM.bindData.chosenQuote.value;
                return endorsementVM.quoteData.offeredQuotes.value.find((q) => q.publicID === selectedQuoteId);
            }
            return null;
        };   

        const costsAreEqual = (costA, costB) => {
            if (costA && costB) {
                return costA.amount === costB.amount && costA.currency === costB.currency;
            }
            return true;
        };

        const isBlockingUWIssue = (uwIssue) => {
            return uwIssue.currentBlockingPoint !== MLUWIssuesBlockingPoints.NON_BLOCKING;
        };

        const getBlockingUWIssues = () => {
            return endorsementVM.value.uwIssues_ML && endorsementVM.value.uwIssues_ML.length
                ? endorsementVM.value.uwIssues_ML.filter((uwIssue) => isBlockingUWIssue(uwIssue))
                : [];
        };

        const foundViolationsFromReport = () => {
            const hasViolationsFromReport = (array) => {
                return array.some((v) => v.source === 'lexisNexis');
            };
            return hasViolationsFromReport(violations);
        };

        if (mvrExecuted) {
            const storagePromise = MLPortalStorageService.retrieve(endorsementVM.jobID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, authHeader);
            // ModalService.showProgressDialog('ml.quoteandbind.common.controllers.MLDisclosureCtrl.Synchronizing quote...', storagePromise);
            storagePromise.then((response) => {
                if (response) {
                    const formerCosts = JSON.parse(response);
                    const flag = !costsAreEqual(formerCosts.total, endorsementVM.totalCost.value);
                    MLDisclosureUtil.setRequoteAfterMvr(endorsementVM.jobID.value, flag);
                    updatePremiumChangedByMVRFlag(flag);

                    if (flag) {
                        setUwIssues(getBlockingUWIssues());
                        endorsementVM.value.blockNavigation_ML = uwIssues.length > 0;
                    }
                } else {
                    updatePremiumChangedByMVRFlag(false);
                }
            }, () => updatePremiumChangedByMVRFlag(false));
            
            storagePromise.finally(() => {
                endorsementVM.value.blockNavigation_ML = premiumChangedByMVRFlag && uwIssues.length > 0;
                if (isAgent &&  !_.isUndefined(premiumChangedByMVRFlag) && !(premiumChangedByMVRFlag || foundViolationsFromReport())) {
                    goNext(true)
                }
                if (isAgent &&  !_.isUndefined(premiumChangedByMVRFlag) && (premiumChangedByMVRFlag || foundViolationsFromReport())) {
                    setShowDisclosuresPagePolChange(true); 
                }
            });

        }
    };

    const displayMVRDedupedWarning = () => {
        clearBlockAlerts(PREMIUM_CHANGED_ALERT_BLOCK);
        if(endorsementVM?.value.mvrDeduped_Ext)
            addWarningAlert(messages.premiumChangedDueToInfoReceivedAgent, PREMIUM_CHANGED_ALERT_BLOCK);
    }

    const ageLessThanThreshold = (driver) => {
        return currentYear - driver.dateOfBirth.year < PA_LIC_SUSP_DRIVERS_AGE_THRESHOLD;
    };

    const isSuspension = (violation) => {
        return currentYear - violation.date.year < PA_LIC_SUSP_INCIDENT_THRESHOLD_IN_YEARS && (violation.type === PA_LIC_SUSP_LICENSE_SUSPENDED_TYPE || violation.code === PA_LIC_SUSP_LICENSE_SUSPENDED_CODE);
    };

    const hasPASuspension = (driver) => {
        return driver.disclosures_ML.violations.some((violation) => isSuspension(violation));
    };

    const pADriverSuspended = () => {
        return endorsementVM.value.baseData.policyAddress.state === 'PA' && endorsementVM.value.lobData.personalAuto !== undefined && endorsementVM.value.lobData.personalAuto.coverables.drivers.some((driver) => {
            return ageLessThanThreshold(driver) && hasPASuspension(driver);
        });
    };

    const callPADriverSuspended = () => {
        // $scope.$emit('paDriverSuspended');
        updatePaSuspensionMessagedDisplayed(true);
    };

    /*
     * Check if there is any disclosure coming from a report
     */
    const foundViolationsFromReport = () => {
        const hasViolationsFromReport = (array) => {
            return array.some((v) => v.source === 'lexisNexis');
        };
        return hasViolationsFromReport(violations);
    };

    const filterDriversForAutoandUmb = (driver, type) => {
        return driver.hasOwnProperty('type_ML') && driver.type_ML === type || driver.hasOwnProperty('driverType') && driver.driverType === type;
    };

    const getDrivers = () => {
        let drivers = [];
        if (isPersonalAuto && lobModel.value.drivers) {
            drivers = lobModel.value.drivers;
        } else if (isPersonalUmbrella && lobModel.value.vehicleOperators) {
            drivers = lobModel.value.vehicleOperators;
        }
        return drivers.filter((driver) => 
            filterDriversForAutoandUmb(driver, 'rated') 
            || (filterDriversForAutoandUmb(driver, 'excluded') && discloseExcludedDriver)
        );
    };

    /*
     * Get the list of available drivers/vehicle operators
     */
    const getOwners = () => {
        const owners = [];
        const drivers = getDrivers();
        if (isPersonalAuto) {
            drivers.forEach((d) => owners.push(d.person));
        } else if (isPersonalUmbrella) {
            drivers.forEach((v) => owners.push(v.contact));
        }
        return owners;
    };

    const getDisclosuresFromDriver = (driver) => {
        return driver.disclosures_ML || driver.disclosures || driver.disclosure;
    };

    const getMvrStatus = () => {
        if (foundViolationsFromReport()) {
            return MLDisclosureUtil.mvrStatus.FOUND_VIOLATIONS;
        } 
        return  MLDisclosureUtil.mvrStatus.NO_VIOLATIONS;
    };

    const getPrimaryNamedInsuredState = () => {
        return _.get(endorsementVM, 'baseData.primaryNamedInsured_ML.primaryAddress.state.value.code');
    };

    const initDisclosures = () => {
        const drivers = getDrivers();
        let assignedAccidents = [];
        let assignedClaims = [];
        let assignedViolations = [];
        drivers.forEach((driver) => {
            const disclosures = getDisclosuresFromDriver(driver);
            if (disclosures) {
                if (!_.isUndefined(disclosures.accidents)) {
                    assignedAccidents = assignedAccidents.concat(disclosures.accidents);
                }
                if (!_.isUndefined(disclosures.claims)) {
                    assignedClaims= assignedClaims.concat(disclosures.claims);
                }
                if (!_.isUndefined(disclosures.violations)) {
                    assignedViolations = assignedViolations.concat(disclosures.violations);
                }
            }
        })

        assignedAccidents.forEach((a) => { a.originalOwner = a.person.publicID; });
        assignedClaims.forEach((c) => { c.originalOwner = c.person.publicID; });
        assignedViolations.forEach((v) => { v.originalOwner = v.person.publicID; });

        setAccidents(assignedAccidents);
        setClaims(assignedClaims);
        setViolations(assignedViolations);

        if (!isPersonalAuto && lobModel.homeLosses_ML.value) {
            setLosses(losses.concat(lobModel.homeLosses_ML.value));
        }
    };


    const showPremiumChangedAlert = useCallback(() => {
        if (isPersonalAuto || isPersonalUmbrella) {
            clearBlockAlerts(PREMIUM_CHANGED_ALERT_BLOCK);
            addWarningAlert(messages.premiumChangedDueToInfoReceivedAgent, PREMIUM_CHANGED_ALERT_BLOCK);
        }
    }, [addWarningAlert, clearBlockAlerts, isPersonalAuto , isPersonalUmbrella]);

    const showHIDriverMVRReportPendingAlert = useCallback(() => {
        if (isPersonalAuto) {
            addErrorAlert(messages.orderMVRforHIDriverAgent, 'HIDriverMVRPendingAlert');
        }
    }, [addErrorAlert, isPersonalAuto]);


    const displayHIDriverWarning = () => {
        const drivers = _.get(endorsementVM, 'lobData.personalAuto.coverables.drivers.value');
        if( checkHiDrivers (drivers) &&  checkPendingMvrOrderStatus(drivers))
            return true;
        return false;    
    } 

    useEffect(() => {
        initDisclosures();

        if(currentStep.mlStepName==='endorsementPaDisclosures' && displayHIDriverWarning()){
            showHIDriverMVRReportPendingAlert();
        };
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
        displayMVRDedupedWarning();
    }, []);

    useEffect(() => {
        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Reached', false, endorsementVM, authHeader, { step: 'PolChange Disclosure Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        setPremiumChangedByMVRFlag();

        if((currentStep.mlStepName==='endorsementPaDisclosures' || currentStep.mlStepName==='endorsementPupDisclosures') && premiumChangedByMVRFlag ){
            showPremiumChangedAlert();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [premiumChangedByMVRFlag]);

    const assignDisclosuresToDrivers = () => {
        const _assignDisclosures = (driver, disclosuresOrig, disclosuresDest) => {
            const publicID = isPersonalUmbrella ? driver.contact.publicID : driver.person.publicID;

            disclosuresOrig.forEach((disclosure) => {
                if (disclosure && disclosure.person.publicID === publicID && (_.isUndefined(disclosure.removeReason) || disclosure.removeReason === null)) {
                    if (disclosure.originalOwner !== disclosure.person.publicID) {
                        disclosure.fixedID = null;
                    }
                    disclosuresDest.push(disclosure);
                }
            });
        };
        const _clearDriverDisclosures = (disclosures) => {
            disclosures.accidents = [];
            disclosures.claims = [];
            disclosures.violations = [];
        };

        const drivers = getDrivers();
        drivers.forEach((driver) => {
            const disclosures = getDisclosuresFromDriver(driver);
            _clearDriverDisclosures(disclosures);
            _assignDisclosures(driver, accidents, disclosures.accidents);
            _assignDisclosures(driver, claims, disclosures.claims);
            _assignDisclosures(driver, violations, disclosures.violations);
        });
    };

    const showHomeLossesOnly = () => {
        const drivers = getDrivers();
        return !isPersonalAuto && drivers.length <= 0;
    };

    const saveHomeLosses = () => {
        if (!isPersonalAuto && losses) {
            lobModel.homeLosses_ML.value = losses.filter((loss) => {
                return _.isUndefined(loss.removeReason) || loss.removeReason === null;
            });
        }
    };        

    const approvedAllBlockingUWIssuesCallback = useCallback(() => {
        _.set(endorsementVM, 'value.blockNavigation_ML', false);
    }, [endorsementVM]);

    const bindFlow = async () => {
        const productCode = _.get(endorsementVM, 'baseData.productCode.value', '');

        const canSkipSignatures = (MLNavigationStepsTrackingService.shouldQuickBind() && endorsementVM.baseData.signatureRequired_ML.value === false);
        if (canSkipSignatures) {
            const bindPromise = EndorsementService.bindEndorsement(endorsementVM.jobID.value, endorsementVM.paymentDetails_ML.value, authHeader);
            showProgressDialog(platformMessages.savingPolicyChange, bindPromise);
            bindPromise.then(({ policyChange, ...rest }) => {
                endorsementVM.value = new PolicyChange(policyChange, rest);
                updateWizardData(wizardData);
                // go to endorsementConfirmation
                MLEndorsementFlowUtil.findStepAndChangeNextStep(productCode, 'endorsementConfirmation', changeNextSteps);
                goNext();
            });
        } else if (isAgent) {
            const uwPromise = EndorsementService.evaluateUWPrebind(endorsementVM.jobID.value, authHeader);
            showProgressDialog(platformMessages.savingPolicyChange, uwPromise);
            uwPromise.then((uwIssuesRes) => {
                endorsementVM.value.uwIssues_ML = uwIssuesRes;
                updateWizardData(wizardData);
                MLEndorsementFlowUtil.findStepAndChangeNextStep(productCode, 'endorsementSignatureOptions', changeNextSteps);
                goNext();
            });
        } else {
            // temporary commenting out this as userType should be other for CE
            // else if (submissionVM.baseData.userType_ML.value && submissionVM.baseData.userType_ML.value.code === 'other' && !isGpa) {

            // go to endorsementESignature
            MLEndorsementFlowUtil.findStepAndChangeNextStep(productCode, 'endorsementESignature', changeNextSteps);
            goNext();
        }
    }

    const goToNext = () => {
        if (isPersonalAuto) {
            // go to veracity check
            goNext();
        } else {
            // go to bind entry for pup
            bindFlow();
        }
    }

    const handleNext = () => {
        const indexOfSummary = _.findIndex(
            steps,
            ({ path }) => path === '/summary'
        );
        if (!isAgent) {
            goToNext();
        } else {
            premiumChangedByMVRFlag ? jumpTo(indexOfSummary) : goToNext();
        }
    }

    const saveAndQuote = () => {
        const promise = EndorsementService.saveAndQuote(endorsementVM.value, authHeader)
        showProgressDialog(platformMessages.quotingPolicyChange, promise);
        promise.then((responseData) => {
            MLTagManagerService.sendFormStepPolicyChangeStep();
            endorsementVM.value = new PolicyChange(responseData);
            updateWizardData(wizardData);
            handleNext();
        });
    };

    // syntheticBaseEvent contains the onClick event
    const onNext = (syntheticBaseEvent, bypassSave = false) => {
        if (!isComponentValid) {
            return;
        }
        
        if (mvrExecuted) {
            if (pADriverSuspended() && !paSuspensionMessagedDisplayed) {
                callPADriverSuspended();
                return;
            }
        }

        assignDisclosuresToDrivers();
        saveHomeLosses();

        if (!bypassSave && isAgent) {
            saveAndQuote();
        } else {
            handleNext();
        }

        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, endorsementVM, authHeader, {
                step: 'PolChange Disclosure Screen',
                action: 'PolChange Disclosure Submitted'
            });
        }

    };

    const resolvers = {
        resolveComponentMap: {
            mldisclosurecomponent: MLDisclosureComponent,
            mlscriptcomponent: MLScriptComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        },
        resolveCallbackMap: {
            onNext
        }
    };

    const getAmpContinueMessage = () => {
        const signNeeded = endorsementVM.baseData.signatureRequired_ML.value;
        const message = signNeeded ? messages.signNeededDescription : messages.signNotNeededDescription;
        return <>{translator(message, {
            strong: (chunks) => <strong>{chunks}</strong>
        })}</>
    }

    const overrideProps = {   
        ampSubsectionHeader: {
            visible: !isAgent
        },
        discloseExcludedDriverInfo: {
            visible: discloseExcludedDriver
        },
        uwIssuePanel: {
            visible: premiumChangedByMVRFlag === false,
            uwIssues,
            jobID: quoteID,
            wrapped: true,
            approvedAllBlockingUWIssuesCallback
        },
        mlLossesComponent: {
            disclosures: losses,
            owners: getOwners(),
            type: MLDisclosureUtil.getLossType(),
            showAddButton: false,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: isAgent,
            policyHolder
        },
        accidentsRow: {
            visible: !showHomeLossesOnly()
        },
        mlAccidentsComponent: {
            disclosures: accidents,
            owners: getOwners(),
            type: MLDisclosureUtil.getAccidentType(),
            showAddButton: false,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: isAgent,
            drivers: getDrivers(),
            isPersonalAuto,
            shouldDiscloseExcluded: discloseExcludedDriver,
            policyHolder
        },
        claimsRow: {
            visible: !showHomeLossesOnly()
        },
        mlClaimsComponent: {
            disclosures: claims,
            owners: getOwners(),
            type: MLDisclosureUtil.getClaimType(),
            showAddButton: false,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: isAgent,
            drivers: getDrivers(),
            isPersonalAuto,
            shouldDiscloseExcluded: discloseExcludedDriver,
            policyHolder,
            isPolicyChange:true
        },
        violationsRow: {
            visible: !showHomeLossesOnly()
        },
        mlViolationsComponent: {
            disclosures: violations,
            owners: getOwners(),
            type: MLDisclosureUtil.getViolationType(),
            mvrStatus: getMvrStatus(),
            showAddButton: false,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: isAgent,
            drivers: getDrivers(),
            isPersonalAuto,
            shouldDiscloseExcluded: discloseExcludedDriver,
            primaryNamedInsuredState: getPrimaryNamedInsuredState(),
            policyHolder
        },
        nextDescription: {
            content: (
                mvrExecuted ?
                    <FormattedMessage
                        {...messages.confirmPremiumNextText}
                        values={{
                            confirmPremium: (
                                <strong>{translator(messages.confirmPremium)}</strong>
                            )
                        }}
                    />
                    :
                    <FormattedMessage
                        {...messages.continueText}
                        values={{
                            reviewYourQuote: (
                                <strong>{translator(messages.reviewYourQuote)}</strong>
                            )
                        }}
                    />
            )
        },
        stickyfootercomponent: {
            visible: isAgent,
            defaultContinueSectionId: 'footer',
            nextDescription:
                (
                    mvrExecuted ?
                        <FormattedMessage
                            {...messages.confirmPremiumNextText}
                            values={{
                                confirmPremium: (
                                    <strong>{translator(messages.confirmPremium)}</strong>
                                )
                            }}
                        />
                        :
                        <FormattedMessage
                            {...messages.continueText}
                            values={{
                                reviewYourQuote: (
                                    <strong>{translator(messages.reviewYourQuote)}</strong>
                                )
                            }}
                        />
                ),
            onNext
        },
        nextButton : {
            disabled: displayHIDriverWarning()
        },
        PADisclosureContainer: {
            visible: showDisclosuresPagePolChange
        },
        gatewayPupDisclosureContainer: {
            visible: showDisclosuresPagePolChange
        }
    };
    if(!isAgent){
        overrideProps.nextDescription.content = getAmpContinueMessage();
    }

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={currentStep.title}
        >
            <ViewModelForm
                uiProps={isPersonalAuto ? paMetadata.pageContent : pupMetadata.pageContent}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

DisclosurePagePolChange.propTypes = wizardProps;

export default DisclosurePagePolChange;